var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner q-mt-md q-mb-md"},[_c('q-banner',{staticClass:"text-white",class:_vm.bgClass,attrs:{"rounded":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }